<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id" >
            <!-- <template slot="operation" slot-scope="text, record">
                <router-link class="tableLink" :to="{path:'detail_channel',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'edit_channel',query: {id: record.id,}}">渠道设置</router-link>
            </template> -->

            <template slot="status" slot-scope="text">
               <span v-if="text == '02'">
                   已读
               </span>
               <span v-else-if="text == '01'">
                   未读
               </span>
               <span v-else>
                   --
               </span>
            </template>

            <template slot="messageService" slot-scope="text">
               <span>
                   {{ getMessageServiceName(text) }}
               </span>
            </template>

            <template slot="platformID" slot-scope="text">
               <span>
                   {{ getPlatformName(text) }}
               </span>
            </template>

            <template slot="opration" slot-scope="record">
                    <a-icon style="color:#1890ff;" size="large" type="file-search" @click="handleDetail(record)" />
                </template>
        </a-table>

        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
        <a-modal v-model="modalVisible" title="报文" @ok="handleOk">
                 <json-viewer
                    :value="modalData"
                    :expand-depth=5
                    copyable
                    boxed
                    sort></json-viewer>
            </a-modal>
    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};

const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        },
        fixed: 'left'

    },
    {
        title: "消息ID",
        dataIndex: "messageid",
        align: 'center',
        ellipsis:true,
        fixed: 'left',
        width:120
    },
    {
        title: "消息记录ID",
        dataIndex: "messagerecordid",
        align: 'center',
        ellipsis:true,
        fixed: 'left',
        width:120
    },
    {
        title: "详情",
        width:50,
        scopedSlots: { customRender: 'opration' },
        align: "center",
        ellipsis: true,
        fixed: 'left'
    },
    {
        title: "通道类型",
        dataIndex: "passwaytypename",
        align: 'center',
        ellipsis:true,
        width:80
    },
    {
        title: "平台编码",
        dataIndex: "platformcode",
        align: 'center',
        ellipsis:true,
        width:100
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        align: 'center',
        width:160
    },
    {
        title: "接收人",
        dataIndex: "userid",
        align: 'center',
        width:100,
        ellipsis:true,
    },
    {
        title: "状态",
        dataIndex: "readstatus",
        scopedSlots: { customRender: 'status' },
        align: 'center',
        width:80
    },
    {
        title: "标题",
        dataIndex: "messagetitle",
        align: 'center',
        width:300,
        ellipsis:true,
    },
    {
        title: "正文",
        dataIndex: "messageecontent",
        align: 'center',
        width:300,
        ellipsis:true,
    },
    // {
    //   title: "渠道名称",
    //     dataIndex: "channelname",
    //    align: 'center',
    //     ellipsis:true,
    //      width:180
    //  },


    {
        title: "业务类型",
        dataIndex: "messageservicename",
        scopedSlots: { customRender: 'messageService' },
        align: 'center',
        ellipsis:true,
        width:120
    },
    {
        title: "消息类型",
        dataIndex: "messagestypename",
        scopedSlots: { customRender: 'messageService' },
        align: 'center',
        ellipsis:true,
        width:120
    },
    {
        title: "额外参数",
        dataIndex: "messageextras",
        align: 'center',
        ellipsis:true,
        width:180
    }


];


import {mapState} from "vuex";
import JsonViewer from "vue-json-viewer"


export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            modalData:{},
            modalVisible:false,
            searchP:{
                keyword:'',
                channelcode:'',
                channels:[]
            }
        };
    },
    methods: {
        handleOk(){
            this.modalVisible = false;
        },
        handleDetail(record){
            this.modalData = record;
            this.modalVisible = true;
        },
        getMessageServiceName(text){
            let targetItem = this.messageServiceList.filter( item => { return item.passwaytype == text } );
            if(targetItem.length > 0){
                return targetItem[0].messageservicename
            }
            else{
                return text;
            }
        },
        getPlatformName(text){
            let targetItem = this.platformtypeList.filter( item => { return item.platformtype == text } );
            if(targetItem.length > 0){
                return targetItem[0].platformtypename
            }
            else{
                return text;
            }
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },

        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "mcmsmanager/selectMcmsMessageRecordsPage",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        }
    },
    computed: {
        ...mapState('mcmsmanager', {
            messageServiceList: state => state.messageServiceList,
            platformtypeList:state => state.platformtypeList,

        })
    },
    components:{
        JsonViewer
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

